var map = {
	"./Arrow-Rotate.svg": "a2c7",
	"./Arrow-down.svg": "f4be",
	"./Arrow-next.svg": "0cb6",
	"./Arrow-prev.svg": "1d60",
	"./Blank.svg": "58bf",
	"./Check-big-inner.svg": "2d7d",
	"./Check-disabled.svg": "b7da",
	"./Check.svg": "be7e",
	"./Delete-circle.svg": "bc8f",
	"./Delivery-Truck-Fast.svg": "2dd0",
	"./Document.svg": "9919",
	"./File-Pdf.svg": "7887",
	"./Full-Screen.svg": "47b7",
	"./Headphones.svg": "c0a5",
	"./Money-Coins.svg": "536d",
	"./Money-track.svg": "5908",
	"./Pen-Edit.svg": "6aa5",
	"./Pen.svg": "a225",
	"./Pin-Location.svg": "1f4e",
	"./Plus-Add.svg": "12a7",
	"./Settings-seach.svg": "37cf",
	"./Temperature.svg": "8397",
	"./add-iot-icon.svg": "8400",
	"./add-point-icon.svg": "04d5",
	"./amex-icon.svg": "1f6a",
	"./arrow-calendar.svg": "c723",
	"./arrow-icon.svg": "8486",
	"./arrow-list-icon.svg": "b994",
	"./arrow-sort.svg": "6055",
	"./bell-notifications.svg": "98f6",
	"./bullet-list-text.svg": "5890",
	"./calendar-card-icon.svg": "8859",
	"./calendar-light.svg": "3280",
	"./carbon-icon.svg": "7813",
	"./chart-temperature.svg": "2fbe",
	"./checkmark-circle-big.svg": "69c5",
	"./checkmark-circle.svg": "87fe",
	"./clock-watch.svg": "6207",
	"./close-foll-screen.svg": "d58b",
	"./close-icon.svg": "390f",
	"./crop-icon.svg": "2511",
	"./definition-icon.svg": "27d2",
	"./diners-icon.svg": "34ee",
	"./discover-icon.svg": "c6b6d",
	"./document-file-table.svg": "e065",
	"./dots-menu.svg": "c56c",
	"./double-arrow.svg": "5d35",
	"./filter-icon.svg": "ad40",
	"./grapes.svg": "d0d3",
	"./ico-arrow-clock.svg": "c446",
	"./ico-buildings-list.svg": "80c0",
	"./ico-bullet-list.svg": "58dc",
	"./ico-call.svg": "4681",
	"./ico-checklist-pin.svg": "875e",
	"./ico-checklist-round.svg": "b497",
	"./ico-country-house.svg": "3c69",
	"./ico-download.svg": "0215",
	"./ico-exit-log-out-arrow.svg": "052e",
	"./ico-file-chart.svg": "8b58",
	"./ico-folder.svg": "3cd7",
	"./ico-gear.svg": "8a22",
	"./ico-grapes.svg": "a460",
	"./ico-lamb.svg": "a7ee",
	"./ico-mail.svg": "01b2",
	"./ico-map.svg": "b2a9",
	"./ico-package.svg": "7ed6",
	"./ico-phone.svg": "5515",
	"./ico-qr-code.svg": "94e0",
	"./ico-question.svg": "a691",
	"./ico-remove.svg": "7434",
	"./ico-scroll-left.svg": "cade",
	"./ico-scroll-right.svg": "87b7",
	"./ico-setting.svg": "fb83",
	"./ico-settings.svg": "8182",
	"./ico-signal.svg": "a7cd",
	"./ico-single-user-add.svg": "fe1f",
	"./ico-speedo.svg": "e398",
	"./ico-tools-equipments.svg": "5312",
	"./ico-truck.svg": "785c",
	"./ico-users.svg": "b664",
	"./info-card-icon.svg": "c318",
	"./ingoing-icon.svg": "ec99",
	"./jcb-icon.svg": "c77b",
	"./light-icon.svg": "9504",
	"./location-icon.svg": "cad4",
	"./logo-icon.svg": "1515",
	"./logo-text.svg": "38b8",
	"./map-location-pin.svg": "d74e",
	"./mastercard-icon.svg": "894d",
	"./message-question-checkmark.svg": "eb64",
	"./mobile-logo-icon.svg": "a18b",
	"./moinsture-icon.svg": "63b0",
	"./network-icon-card.svg": "3d47",
	"./notification-1.svg": "ef44",
	"./notification-2.svg": "0105",
	"./notification-3.svg": "613a",
	"./notification-4.svg": "5ffe",
	"./notification-5.svg": "8fcb",
	"./notification-6.svg": "2914",
	"./notification-7.svg": "626a",
	"./power-icon-card.svg": "e7e0",
	"./privot-aria-icon.svg": "c616",
	"./qr-code-big.svg": "6a71",
	"./report-card-icon.svg": "424c",
	"./return-dispatch-icon.svg": "8156",
	"./round-plus-icon.svg": "e5e1",
	"./search-loupe.svg": "8f9e",
	"./setting-square.svg": "4d02",
	"./settings-card-icon.svg": "0c65",
	"./star-icon.svg": "7aa3",
	"./star.svg": "d8e7",
	"./success-arrow.svg": "9bde",
	"./success-icon.svg": "d4a9",
	"./success-list-icon.svg": "4374",
	"./suitcase-portfolio.svg": "166e",
	"./tempa-icon.svg": "bde3",
	"./time-arrow-up.svg": "764e",
	"./to_top.svg": "6472",
	"./transportations.svg": "56c8",
	"./trash-delete.svg": "7007",
	"./upload-arrow.svg": "dd8a",
	"./upload-icon.svg": "0eb0",
	"./upload-image-icon.svg": "4e10",
	"./visa-icon.svg": "d795",
	"./wifi-icon.svg": "eeb3",
	"./x.svg": "8540"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0591";